import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateObservatoryNotes } from "../api/accommodation.api";
import { toast } from "@/hooks/use-toast";
import { AxiosError } from "axios";

interface ErrorResponse {
  message: string;
}

export const useObservatoryNotesUpdate = (accommodationId?: string) => {
  const queryClient = useQueryClient();

  const { mutate: saveNotes, isPending: isSaving } = useMutation({
    mutationFn: (data: { observatoryNotes: string | null }) => {
      if (!accommodationId) {
        throw new Error('Se requiere un ID para actualizar las notas');
      }
      return updateObservatoryNotes(accommodationId, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["accommodation", accommodationId] });
      toast({
        title: "Notas guardadas",
        description: "Las notas del observatorio fueron guardadas correctamente.",
      });
    },
    onError: (error: AxiosError<ErrorResponse>) => {
      toast({
        title: "Error",
        description: error?.response?.data?.message || "Ocurrió un error al guardar las notas.",
        variant: "destructive",
      });
    },
  });

  return {
    saveNotes,
    isSaving,
  };
};
